import { H2, P3 } from '@/lib/shared/components/Typography';
import { TgIcon, SvgTelegram } from '@/lib/shared/icons';
import { sendSocialClick } from '@/lib/shared/utils/send-gtm';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './TgCard.module.scss';

import { Button } from '../../Buttons';

type TgCardProps = {
  type?: 'rent';
  href: string;
};

export const TgCard = ({ type, href }: TgCardProps) => {
  const { t } = useTranslation('index', { keyPrefix: 'landingApartments' });
  return (
    <div className={styles.tgCard}>
      <Image
        src={'/leaves/image.webp'}
        sizes="100vw"
        width={874}
        height={606}
        alt=""
        className={styles.tgCard__leaves}
      />
      <div className={styles.tgCard__tgIcon}>
        <TgIcon />
      </div>
      <div className={styles.tgCard__content}>
        <H2
          className={cn(
            styles.tgCard__title,
            type === 'rent' && styles['tgCard__title--rent']
          )}
        >
          {type === 'rent'
            ? t('telegramCardTitleRent')
            : t('telegramCardTitle')}
        </H2>
        <P3 className={styles.tgCard__description}>
          {type === 'rent'
            ? t('telegramCardDescriptionRent')
            : t('telegramCardDescription')}
        </P3>
        <Button
          label={t('telegramCardButton')}
          theme="light-invert"
          size="lg"
          as="a"
          target="_blank"
          href={href}
          icon={<SvgTelegram />}
          className={styles.tgCard__button}
          onClick={sendSocialClick}
        />
      </div>
    </div>
  );
};
